<air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
<div class="share-account__description" [internalInnerHtml]="content.description" [userEventSource]="userEventSource"></div>

<ng-container *ngIf="!noEmailExists; else noEmailBlock" [class.loading]="isLoading">
  <div class="share-account--top-block" *ngIf="!isMerged && receivedInvitations.length > 0">
    <h3>{{ "share_account.label.you_are_invited" | translate }}</h3>
    <ng-container *ngFor="let receivedInvitation of receivedInvitations">
      <ng-container
        *ngTemplateOutlet="
          invitationBlock;
          context: receivedInvitation.isCancelled
            ? {
                invitationBlockType: invitationBlockType.cancelled,
                title: content.cancelledInvitationText.title.format([receivedInvitation.senderEmailAddress]),
                body: content.cancelledInvitationText.body,
                invitationBlock: {
                  invitationId: receivedInvitation.invitationId,
                  isLoading: false
                }
              }
            : {
                invitationBlockType: invitationBlockType.received,
                title: content.receivedInvitationText.title.format([receivedInvitation.senderEmailAddress]),
                body: content.receivedInvitationText.body,
                invitationId: receivedInvitation.invitationId,
                invitationBlock: {
                  invitationId: receivedInvitation.invitationId,
                  isLoading: false
                }
              }
        "
      ></ng-container
    ></ng-container>
  </div>

  <div class="share-account--top-block" *ngIf="isMerged">
    <h3>{{ "share_account.label.currently_sharing" | translate }}</h3>
    <ng-container
      *ngTemplateOutlet="
        invitationBlock;
        context: {
          invitationBlockType: invitationBlockType.stop,
          title: content.stopText.title,
          body: content.stopText.body,
          invitationBlock: {
            invitationId: null,
            isLoading: false
          }
        }
      "
    ></ng-container>
  </div>
  <!-- invitation methods section -->
  <div class="share-account--bottom-block">
    <ng-container *ngIf="sentInvitations.length > 0">
      <ng-container *ngFor="let sentInvitation of sentInvitations">
        <ng-container
          *ngTemplateOutlet="
            invitationBlock;
            context: {
              invitationBlockType: invitationBlockType.sent,
              title: content.sentInvitationText.title.format([sentInvitation.invitedEmailAddress]),
              body: content.sentInvitationText.body,
              invitationBlock: {
                invitationId: sentInvitation.invitationId,
                isLoading: false
              }
            }
          "
        ></ng-container
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="!noEmailExists && !sentInvitations?.length">
      <h3>{{ "share_account.label.send_an_invitation" | translate }}</h3>
      <div class="form">
        <div class="button__group">
          <!-- email address button -->
          <ng-container
            *ngTemplateOutlet="
              invitationMethodButton;
              context: {
                type: 'emailAddress',
                label: 'account.label.email' | translate
              }
            "
          ></ng-container>
          <!-- card number button -->
          <ng-container
            *ngTemplateOutlet="
              invitationMethodButton;
              context: {
                type: 'cardNumber',
                label: 'account.label.card_number' | translate
              }
            "
          ></ng-container>
        </div>
        <!-- email address input field -->
        <div class="form-group" [hidden]="invitationMethodType !== invitationMethod.emailAddress">
          <label
            for="invitation-method--email-address"
            [ngClass]="{
              'form-label--error': emailAddress.dirty && emailAddress.invalid
            }"
          >
            {{ "share_account.label.saver_email_address" | translate }}
          </label>
          <input [formControl]="emailAddress" type="email" id="invitation-method--email-address" />
          <div class="form-error" *ngIf="emailAddress.dirty && emailAddress.invalid">
            <div *ngIf="emailAddress.hasError('email')" class="form-error__message">{{ "account.error.email.invalid" | translate }}</div>
            <div *ngIf="emailAddress.hasError('required')" class="form-error__message">
              {{ "account.error.email.required" | translate }}
            </div>
          </div>
        </div>
        <!-- card number input field -->
        <div class="form-group" [hidden]="invitationMethodType !== invitationMethod.cardNumber">
          <label
            for="invitation-method--card-number"
            [ngClass]="{
              'form-label--error': cardNumber.dirty && cardNumber.invalid
            }"
          >
            {{ "share_account.label.saver_card_number" | translate }}
          </label>
          <input [formControl]="cardNumber" type="text" id="invitation-method--card-number" />
          <div class="form-error" *ngIf="cardNumber.dirty && cardNumber.invalid">
            <div *ngIf="cardNumber.hasError('pattern')" class="form-error__message">
              {{ "account.error.card_number.invalid" | translate }}
            </div>
            <div *ngIf="cardNumber.hasError('required')" class="form-error__message">
              {{ "account.error.card_number.required" | translate }}
            </div>
          </div>
          <small class="form__description">{{ "account.description.card_number" | translate }}</small>
        </div>
      </div>
      <!-- submit button -->
      <button
        type="button"
        class="button form__button button--full-width button--cta"
        [disabled]="formDisabled"
        [airButtonLoading]="isSubmitting"
        (click)="submit($event)"
      >
        <span>{{ "share_account.label.send_invitation" | translate }}</span>
      </button>
    </ng-container>
  </div>
</ng-container>

<ng-template #invitationMethodButton let-type="type" let-label="label">
  <div
    role="button"
    class="button"
    [ngClass]="{
      'button--primary': invitationMethodType === type,
      'button--border': invitationMethodType !== type
    }"
    (click)="setInvitationMethodType(type, $event)"
  >
    <span>{{ label }}</span>
  </div>
</ng-template>

<ng-template #noEmailBlock>
  <h3>{{ content.incompleteAccount.title }}</h3>
  <div class="share-account__description" [internalInnerHtml]="content.incompleteAccount.body" [userEventSource]="userEventSource"></div>
</ng-template>

<ng-template #invitationBlock let-title="title" let-body="body" let-type="invitationBlockType" let-invitationBlock="invitationBlock">
  <div class="toast__item" [class.toast__item--error]="type === invitationBlockType.cancelled">
    <div class="toast__content">
      <h4 class="toast__title">
        {{ title }}
      </h4>
      <div class="toast__message" [internalInnerHtml]="body" [userEventSource]="userEventSource"></div>
    </div>
    <div class="toast__cta">
      <div class="button__group">
        <ng-container [ngSwitch]="type">
          <ng-container *ngSwitchCase="invitationBlockType.sent">
            <button
              class="button button--primary"
              (click)="cancelInvitation(invitationBlock, $event)"
              [airButtonLoading]="invitationBlock.isLoading"
            >
              <span> {{ "share_account.label.revoke" | translate }}</span>
            </button>
          </ng-container>
          <ng-container *ngSwitchCase="invitationBlockType.received">
            <button
              class="button button--secondary"
              (click)="rejectInvitation(invitationBlock, $event)"
              [airButtonLoading]="invitationBlock.isLoading"
            >
              <span>{{ "share_account.label.reject" | translate }}</span>
            </button>
            <button
              class="button button--primary"
              (click)="acceptInvitation(invitationBlock, $event)"
              [airButtonLoading]="invitationBlock.isLoading"
            >
              <span>{{ "share_account.label.accept" | translate }}</span>
            </button>
          </ng-container>
          <ng-container *ngSwitchCase="invitationBlockType.stop">
            <button
              class="button button--primary"
              (click)="stopSharedAccount(invitationBlock, $event)"
              [airButtonLoading]="invitationBlock.isLoading"
            >
              <span>{{ "share_account.label.stop_sharing" | translate }}</span>
            </button>
          </ng-container>
          <ng-container *ngSwitchCase="invitationBlockType.cancelled">
            <button
              class="button button--primary"
              (click)="deleteInvitation(invitationBlock, $event)"
              [airButtonLoading]="invitationBlock.isLoading"
            >
              <span>{{ "general.label.remove" | translate }}</span>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
